// src/components/PublicDashboard.js
import React, { useState, useEffect } from 'react';
import { getGlobalStatsCallable } from '../services/firebase';

// Kleine Komponente für eine einzelne Statistik-Karte
const StatCard = ({ icon, value, label, color }) => (
  <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 transform hover:scale-105 transition-transform duration-300">
    <div className={`text-4xl mb-3 ${color}`}>{icon}</div>
    <div className="text-4xl font-extrabold text-gray-900 dark:text-white">{value}</div>
    <div className="text-md text-gray-500 dark:text-gray-400">{label}</div>
  </div>
);

const PublicDashboard = () => {
  const [stats, setStats] = useState({
    totalMeetings: 0,
    totalTasks: 0,
    totalCompanies: 0,
    totalUsers: 0,
    // activeMeetingsToday wurde aus dem initialen Status entfernt
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const result = await getGlobalStatsCallable();
        setStats(result.data);
      } catch (error) {
        console.error("Fehler beim Abrufen der globalen Statistiken:", error);
        // Entsprechend aus dem Fehlerstatus entfernt
        setStats({ totalMeetings: 'N/A', totalTasks: 'N/A', totalCompanies: 'N/A', totalUsers: 'N/A' });
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return <div className="text-center text-xl mt-20">Lade Statistiken...</div>;
  }

  return (
    <div className="text-center p-4">
      <h1 className="text-5xl font-extrabold text-gray-900 dark:text-white mb-4">
        Willkommen bei Meetform
      </h1>
      <p className="text-xl text-gray-600 dark:text-gray-300 mb-12 max-w-2xl mx-auto">
        Die Seite befindet sich im Aufbau! Die zentrale Plattform für effiziente Besprechungsprotokolle und Aufgabenverwaltung.
      </p>

      {/* Grid-Layout für 4 Kacheln angepasst (2x2 auf größeren Bildschirmen) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12">
        <StatCard icon="📊" value={stats.totalMeetings} label="Erstellte Protokolle" color="text-blue-500" />
        <StatCard icon="✔️" value={stats.totalTasks} label="Verwaltete Aufgaben" color="text-green-500" />
        <StatCard icon="🏢" value={stats.totalCompanies} label="Registrierte Firmen" color="text-indigo-500" />
        {/* Label geändert */}
        <StatCard icon="👥" value={stats.totalUsers} label="Erstellte Benutzer" color="text-purple-500" />
        {/* Die Kachel "Meetings heute" wurde vollständig entfernt */}
      </div>
    </div>
  );
};

export default PublicDashboard;
